import PiAI01Stroke from '../@pika/stroke/ai-01.svg';
import PiAlertTriangleStroke from '../@pika/stroke/alert-triangle.svg';
import PiArrowLeftStroke from '../@pika/stroke/arrow-left.svg';
import PiArrowRightStroke from '../@pika/stroke/arrow-right.svg';
import PiAtMarkStroke from '../@pika/stroke/at-mark.svg';
import PiAudioBars01Stroke from '../@pika/stroke/audio-bars-01.svg';
import PiBookmarkCancelStroke from '../@pika/stroke/bookmark-cancel.svg';
import PiBookmarkDefaultStroke from '../@pika/stroke/bookmark-default.svg';
import PiBulbDefaultStroke from '../@pika/stroke/bulb-default.svg';
import PiBulbOffStroke from '../@pika/stroke/bulb-off.svg';
import PiBurgerMenuThreeStroke from '../@pika/stroke/burger-menu-three.svg';
import PiBurgerMenuTwoStroke from '../@pika/stroke/burger-menu-two.svg';
import PiCalendarCheckStroke from '../@pika/stroke/calendar-check.svg';
import PiCalendarDefaultStroke from '../@pika/stroke/calendar-default.svg';
import PiCalendarEventStroke from '../@pika/stroke/calendar-event.svg';
import PiCameraAddStroke from '../@pika/stroke/camera-add.svg';
import PiCaptionOffStroke from '../@pika/stroke/caption-off.svg';
import PiCaptionOnStroke from '../@pika/stroke/caption-on.svg';
import PiChatChattingStroke from '../@pika/stroke/chat-chatting.svg';
import PiChatDefaultStroke from '../@pika/stroke/chat-default.svg';
import PiCheckTickCircleStroke from '../@pika/stroke/check-tick-circle.svg';
import PiCheckTickDoubleStroke from '../@pika/stroke/check-tick-double.svg';
import PiCheckTickSingleStroke from '../@pika/stroke/check-tick-single.svg';
import PiCheckTickSquareStroke from '../@pika/stroke/check-tick-square.svg';
import PiChevronDownStroke from '../@pika/stroke/chevron-down.svg';
import PiChevronLeftStroke from '../@pika/stroke/chevron-left.svg';
import PiChevronRightStroke from '../@pika/stroke/chevron-right.svg';
import PiChevronUpStroke from '../@pika/stroke/chevron-up.svg';
import PiCircleDotStroke from '../@pika/stroke/circle-dot.svg';
import PiCircleRadioStroke from '../@pika/stroke/circle-radio.svg';
import PiCircleStroke from '../@pika/stroke/circle.svg';
import PiClockDefaultStroke from '../@pika/stroke/clock-default.svg';
import PiCopyDefaultStroke from '../@pika/stroke/copy-default.svg';
import PiCreditCardStroke from '../@pika/stroke/credit-card.svg';
import PiDeleteDustbin02Stroke from '../@pika/stroke/delete-dustbin-02.svg';
import PiDiscountBadgeStroke from '../@pika/stroke/discount-badge.svg';
import PiDoorOpenStroke from '../@pika/stroke/door-open.svg';
import PiDownloadDownStroke from '../@pika/stroke/download-down.svg';
import PiDraggableSixDotsStroke from '../@pika/stroke/draggable-six-dots.svg';
import PiDumbbellStroke from '../@pika/stroke/dumbbell.svg';
import PiEnvelopeDefaultStroke from '../@pika/stroke/envelope-default.svg';
import PiEnvelopeFastStroke from '../@pika/stroke/envelope-fast.svg';
import PiExclamationMarkStroke from '../@pika/stroke/exclamation-mark.svg';
import PiExternalLinkSquareStroke from '../@pika/stroke/external-link-square.svg';
import PiEyeOffStroke from '../@pika/stroke/eye-off.svg';
import PiEyeOnStroke from '../@pika/stroke/eye-on.svg';
import PiFilmStroke from '../@pika/stroke/film.svg';
import PiFilterHorizontalStroke from '../@pika/stroke/filter-horizontal.svg';
import PiFireDefaultStroke from '../@pika/stroke/fire-default.svg';
import PiFitnessWalkStroke from '../@pika/stroke/fitness-walk.svg';
import PiGaugeSpeedometerStroke from '../@pika/stroke/gauge-speedometer.svg';
import PiGlobeStroke from '../@pika/stroke/globe.svg';
import PiGraduationHatStroke from '../@pika/stroke/graduation-hat.svg';
import PiHeartStroke from '../@pika/stroke/heart.svg';
import PiHomeDefaultStroke from '../@pika/stroke/home-default.svg';
import PiInformationCircleStroke from '../@pika/stroke/information-circle.svg';
import PiLockCloseStroke from '../@pika/stroke/lock-close.svg';
import PiLogOutRightStroke from '../@pika/stroke/log-out-right.svg';
import PiMapPinStroke from '../@pika/stroke/map-pin.svg';
import PiMaximizeFourArrowStroke from '../@pika/stroke/maximize-four-arrow.svg';
import PiMediaSkipBackward10Stroke from '../@pika/stroke/media-skip-backward-10.svg';
import PiMediaSkipForward10Stroke from '../@pika/stroke/media-skip-forward-10.svg';
import PiMessageQuoteStroke from '../@pika/stroke/message-quote.svg';
import PiMicOnStroke from '../@pika/stroke/mic-on.svg';
import PiMinimizeFourArrowStroke from '../@pika/stroke/minimize-four-arrow.svg';
import PiMultipleCrossCancelCircleStroke from '../@pika/stroke/multiple-cross-cancel-circle.svg';
import PiMultipleCrossCancelDefaultStroke from '../@pika/stroke/multiple-cross-cancel-default.svg';
import PiNoteOutlineStroke from '../@pika/stroke/note-outline.svg';
import PiNotebookStroke from '../@pika/stroke/notebook.svg';
import PiNotificationBellCheckStroke from '../@pika/stroke/notification-bell-check.svg';
import PiNotificationBellOffStroke from '../@pika/stroke/notification-bell-off.svg';
import PiNotificationBellOnStroke from '../@pika/stroke/notification-bell-on.svg';
import PiPartyPopperStroke from '../@pika/stroke/party-popper.svg';
import PiPauseBigStroke from '../@pika/stroke/pause-big.svg';
import PiPencilEraserEditStroke from '../@pika/stroke/pencil-eraser-edit.svg';
import PiPeopleMaleFemaleStroke from '../@pika/stroke/people-male-female.svg';
import PiPeopleMaleMaleStroke from '../@pika/stroke/people-male-male.svg';
import PiPhoneDefaultStroke from '../@pika/stroke/phone-default.svg';
import PiPhotoImagePlusStroke from '../@pika/stroke/photo-image-plus.svg';
import PiPlayBigStroke from '../@pika/stroke/play-big.svg';
import PiPlayCircleStroke from '../@pika/stroke/play-circle.svg';
import PiPlaySquareStroke from '../@pika/stroke/play-square.svg';
import PiPlaylistCheckStroke from '../@pika/stroke/playlist-check.svg';
import PiPlaylistDefaultStroke from '../@pika/stroke/playlist-default.svg';
import PiPlaylistPlayStroke from '../@pika/stroke/playlist-play.svg';
import PiQuestionMarkCircleStroke from '../@pika/stroke/question-mark-circle.svg';
import PiRefreshStroke from '../@pika/stroke/refresh.svg';
import PiReminderAnticlockwiseStroke from '../@pika/stroke/reminder-anticlockwise.svg';
import PiRepeatRectangularStroke from '../@pika/stroke/repeat-rectangular.svg';
import PiRotateLeftStroke from '../@pika/stroke/rotate-left.svg';
import PiRotateRightStroke from '../@pika/stroke/rotate-right.svg';
import PiSearchDefaultStroke from '../@pika/stroke/search-default.svg';
import PiSendPlaneHorizontalStroke from '../@pika/stroke/send-plane-horizontal.svg';
import PiSettings02Stroke from '../@pika/stroke/settings-02.svg';
import PiSignalStroke from '../@pika/stroke/signal.svg';
import PiSparkleAI01Stroke from '../@pika/stroke/sparkle-ai-01.svg';
import PiSquareStroke from '../@pika/stroke/square.svg';
import PiStarStroke from '../@pika/stroke/star.svg';
import PiTagStroke from '../@pika/stroke/tag.svg';
import PiTargetCenterStroke from '../@pika/stroke/target-center.svg';
import PiTextQuotesOpenStroke from '../@pika/stroke/text-quotes-open.svg';
import PiTextQuotesParagraphStroke from '../@pika/stroke/text-quotes-paragraph.svg';
import PiThreeDotsMenuHorizontalStroke from '../@pika/stroke/three-dots-menu-horizontal.svg';
import PiThreeDotsMenuVerticalStroke from '../@pika/stroke/three-dots-menu-vertical.svg';
import PiThumbReactionDislikeStroke from '../@pika/stroke/thumb-reaction-dislike.svg';
import PiThumbReactionLikeStroke from '../@pika/stroke/thumb-reaction-like.svg';
import PiTicketTokenStroke from '../@pika/stroke/ticket-token.svg';
import PiTimerDefaultStroke from '../@pika/stroke/timer-default.svg';
import PiTrendlineUpStroke from '../@pika/stroke/trendline-up.svg';
import PiTrophyStroke from '../@pika/stroke/trophy.svg';
import PiUserCheckStroke from '../@pika/stroke/user-check.svg';
import PiUserDefaultStroke from '../@pika/stroke/user-default.svg';
import PiUserGraduationHatStroke from '../@pika/stroke/user-graduation-hat.svg';
import PiUserSpeakingStroke from '../@pika/stroke/user-speaking.svg';
import PiUserThreeStroke from '../@pika/stroke/user-three.svg';
import PiUserTwoStroke from '../@pika/stroke/user-two.svg';
import PiVideoCallDefaultStroke from '../@pika/stroke/video-call-default.svg';
import PiVideoRecordingStroke from '../@pika/stroke/video-recording.svg';
import PiVolumeMuteStroke from '../@pika/stroke/volume-mute.svg';
import PiVolumeTwoStroke from '../@pika/stroke/volume-two.svg';
import PiWindowPictureInPictureStroke from '../@pika/stroke/window-picture-in-picture.svg';

import PiBookmarkDefaultSolid from '../@pika/solid/bookmark-default.svg';
import PiCheckTickCircleSolid from '../@pika/solid/check-tick-circle.svg';
import PiCheckTickSquareSolid from '../@pika/solid/check-tick-square.svg';
import PiCircleDotSolid from '../@pika/solid/circle-dot.svg';
import PiDiscountBadgeSolid from '../@pika/solid/discount-badge.svg';
import PiHeartSolid from '../@pika/solid/heart.svg';
import PiHomeDefaultSolid from '../@pika/solid/home-default.svg';
import PiNotebookSolid from '../@pika/solid/notebook.svg';
import PiQuestionMarkSquareSolid from '../@pika/solid/question-mark-square.svg';
import PiTextQuotesOpenSolid from '../@pika/solid/text-quotes-open.svg';
import PiThumbReactionLikeSolid from '../@pika/solid/thumb-reaction-like.svg';
import PiLeafStroke from '../@pika/stroke/leaf.svg';

import {IconComponent} from './iconTypes';

export const iconRegistry = {
    stroke: {
        '10-back': PiMediaSkipBackward10Stroke,
        '10-forward': PiMediaSkipForward10Stroke,
        'ai-01': PiAI01Stroke,
        'alert-triangle': PiAlertTriangleStroke,
        'arrow-left': PiArrowLeftStroke,
        'arrow-right': PiArrowRightStroke,
        'at-mark': PiAtMarkStroke,
        audio: PiAudioBars01Stroke,
        bookmark: PiBookmarkDefaultStroke,
        'bookmark-cancel': PiBookmarkCancelStroke,
        bulb: PiBulbDefaultStroke,
        'bulb-off': PiBulbOffStroke,
        'burger-menu': PiBurgerMenuThreeStroke,
        'burger-menu-two': PiBurgerMenuTwoStroke,
        calendar: PiCalendarDefaultStroke,
        'calendar-check': PiCalendarCheckStroke,
        'calendar-event': PiCalendarEventStroke,
        camera: PiCameraAddStroke,
        'caption-off': PiCaptionOffStroke,
        'caption-on': PiCaptionOnStroke,
        chat: PiChatDefaultStroke,
        'chat-chatting': PiChatChattingStroke,
        check: PiCheckTickSingleStroke,
        'check-circle': PiCheckTickCircleStroke,
        'check-double': PiCheckTickDoubleStroke,
        'check-square': PiCheckTickSquareStroke,
        'chevron-down': PiChevronDownStroke,
        'chevron-left': PiChevronLeftStroke,
        'chevron-right': PiChevronRightStroke,
        'chevron-up': PiChevronUpStroke,
        circle: PiCircleStroke,
        'circle-dot': PiCircleDotStroke,
        'circle-radio': PiCircleRadioStroke,
        clock: PiClockDefaultStroke,
        close: PiMultipleCrossCancelDefaultStroke,
        'close-circle': PiMultipleCrossCancelCircleStroke,
        copy: PiCopyDefaultStroke,
        'credit-card': PiCreditCardStroke,
        'discount-badge': PiDiscountBadgeStroke,
        'door-open': PiDoorOpenStroke,
        download: PiDownloadDownStroke,
        dumbbell: PiDumbbellStroke,
        draggable: PiDraggableSixDotsStroke,
        envelope: PiEnvelopeDefaultStroke,
        'envelope-fast': PiEnvelopeFastStroke,
        'exclamation-mark': PiExclamationMarkStroke,
        'external-link': PiExternalLinkSquareStroke,
        'eye-off': PiEyeOffStroke,
        'eye-on': PiEyeOnStroke,
        film: PiFilmStroke,
        filter: PiFilterHorizontalStroke,
        fire: PiFireDefaultStroke,
        'fitness-walk': PiFitnessWalkStroke,
        'gauge-speedometer': PiGaugeSpeedometerStroke,
        globe: PiGlobeStroke,
        'graduation-hat': PiGraduationHatStroke,
        heart: PiHeartStroke,
        home: PiHomeDefaultStroke,
        'information-circle': PiInformationCircleStroke,
        lock: PiLockCloseStroke,
        'log-out': PiLogOutRightStroke,
        'map-pin': PiMapPinStroke,
        maximize: PiMaximizeFourArrowStroke,
        'message-quote': PiMessageQuoteStroke,
        mic: PiMicOnStroke,
        minimize: PiMinimizeFourArrowStroke,
        note: PiNoteOutlineStroke,
        notebook: PiNotebookStroke,
        'notification-bell-check': PiNotificationBellCheckStroke,
        'notification-bell-off': PiNotificationBellOffStroke,
        'notification-bell-on': PiNotificationBellOnStroke,
        pause: PiPauseBigStroke,
        'party-popper': PiPartyPopperStroke,
        'pencil-eraser-edit': PiPencilEraserEditStroke,
        people: PiPeopleMaleFemaleStroke,
        'people-male-male': PiPeopleMaleMaleStroke,
        phone: PiPhoneDefaultStroke,
        'photo-image-plus': PiPhotoImagePlusStroke,
        play: PiPlayBigStroke,
        'play-circle': PiPlayCircleStroke,
        'play-square': PiPlaySquareStroke,
        playlist: PiPlaylistDefaultStroke,
        'playlist-check': PiPlaylistCheckStroke,
        'playlist-play': PiPlaylistPlayStroke,
        'question-mark-circle': PiQuestionMarkCircleStroke,
        'question-mark-square': PiQuestionMarkSquareSolid,
        refresh: PiRefreshStroke,
        'reminder-anticlockwise': PiReminderAnticlockwiseStroke,
        repeat: PiRepeatRectangularStroke,
        'rotate-left': PiRotateLeftStroke,
        'rotate-right': PiRotateRightStroke,
        search: PiSearchDefaultStroke,
        signal: PiSignalStroke,
        'seek-back': PiMediaSkipBackward10Stroke,
        'seek-forward': PiMediaSkipForward10Stroke,
        send: PiSendPlaneHorizontalStroke,
        settings: PiSettings02Stroke,
        'sparkle-ai-01': PiSparkleAI01Stroke,
        square: PiSquareStroke,
        star: PiStarStroke,
        tag: PiTagStroke,
        'target-center': PiTargetCenterStroke,
        'text-quotes': PiTextQuotesParagraphStroke,
        'text-quotes-open': PiTextQuotesOpenStroke,
        'three-dots-menu': PiThreeDotsMenuVerticalStroke,
        'three-dots-menu-horizontal': PiThreeDotsMenuHorizontalStroke,
        'thumb-down': PiThumbReactionDislikeStroke,
        'thumb-up': PiThumbReactionLikeStroke,
        'ticket-token': PiTicketTokenStroke,
        timer: PiTimerDefaultStroke,
        trash: PiDeleteDustbin02Stroke,
        'trendline-up': PiTrendlineUpStroke,
        trophy: PiTrophyStroke,
        user: PiUserDefaultStroke,
        'user-check': PiUserCheckStroke,
        'user-graduation-hat': PiUserGraduationHatStroke,
        'user-speaking': PiUserSpeakingStroke,
        'user-three': PiUserThreeStroke,
        'user-two': PiUserTwoStroke,
        'video-call': PiVideoCallDefaultStroke,
        'video-recording': PiVideoRecordingStroke,
        'volume-mute': PiVolumeMuteStroke,
        'volume-up': PiVolumeTwoStroke,
        pip: PiWindowPictureInPictureStroke,
        leaf: PiLeafStroke,
    },
    solid: {
        bookmark: PiBookmarkDefaultSolid,
        'check-circle': PiCheckTickCircleSolid,
        'check-square': PiCheckTickSquareSolid,
        'circle-dot': PiCircleDotSolid,
        'discount-badge': PiDiscountBadgeSolid,
        heart: PiHeartSolid,
        home: PiHomeDefaultSolid,
        notebook: PiNotebookSolid,
        'question-mark-square': PiQuestionMarkSquareSolid,
        'text-quotes-open': PiTextQuotesOpenSolid,
        'thumb-up': PiThumbReactionLikeSolid,
    },
} as const satisfies {
    stroke: Record<string, IconComponent>;
    solid: Record<string, IconComponent>;
};

export type IconVariant = 'stroke' | 'solid';
export type IconName = keyof (typeof iconRegistry)['stroke'];
export type IconRegistry = {
    [K in keyof typeof iconRegistry]: Record<string, IconComponent>;
};
